import { CalculationService } from './calculation'
import { CalculationServiceDistance } from './calculation/distance'
import { CalculationServiceGreenGRP } from './calculation/green-grp'
import { CalculationServiceLogistics } from './calculation/logistics'
import { CalculationServicePacktech } from './calculation/packtech'
import { CalculationServicePrintPaperPackagingPublishing } from './calculation/ppp'
import { CalculationServiceRotho } from './calculation/rotho'
import { CalculationServiceTravel } from './calculation/travel'
import { CalculationServiceVehicleFleet } from './calculation/vehicle-fleet'
import { CalculationServiceWasteManagement } from './calculation/waste'
import { CommunicationService } from './communication'
import { HealthcheckService } from './healthcheck'
import {
  OrderServiceCollectiveOrders,
  OrderServiceIndividualOrders,
} from './order'
import { StsService } from './sts'
import { UnifiedApiConfiguration } from './types'

export class UnifiedApi {
  private longtermToken: string
  private authorizationStoragePath?: string
  private stsService?: StsService
  private healthCheckService?: HealthcheckService
  private orderServiceIndividualOrders?: OrderServiceIndividualOrders
  private orderServiceCollectiveOrders?: OrderServiceCollectiveOrders
  private calculationService: CalculationService
  private calculationServiceDistance?: CalculationServiceDistance
  private calculationServiceGreenGRP?: CalculationServiceGreenGRP
  private calculationServiceLogistics?: CalculationServiceLogistics
  private calculationServicePacktech?: CalculationServicePacktech
  private calculationServicePrintPaperPackagingPublishing?: CalculationServicePrintPaperPackagingPublishing
  private calculationServiceRotho?: CalculationServiceRotho
  private calculationServiceTravel?: CalculationServiceTravel
  private calculationServiceVehicleFleet?: CalculationServiceVehicleFleet
  private calculationServiceWasteManagement?: CalculationServiceWasteManagement
  private communicationService?: CommunicationService
  private endpointUrl: string

  constructor(options: UnifiedApiConfiguration) {
    const { longtermToken, endpointUrl, authorizationStoragePath } = options
    this.longtermToken = longtermToken
    this.authorizationStoragePath = authorizationStoragePath

    this.endpointUrl = endpointUrl || 'https://unified-api.climatepartner.com'
  }

  getStsService = () => {
    if (!this.stsService) {
      this.stsService = new StsService(
        this.endpointUrl,
        this.longtermToken,
        this.authorizationStoragePath,
      )
    }

    return this.stsService
  }

  getHealthcheckService = () => {
    if (!this.healthCheckService) {
      this.healthCheckService = new HealthcheckService(this.endpointUrl, () =>
        this.getToken(),
      )
    }

    return this.healthCheckService
  }

  getOrderServiceIndividualOrders = () => {
    if (!this.orderServiceIndividualOrders) {
      this.orderServiceIndividualOrders = new OrderServiceIndividualOrders(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.orderServiceIndividualOrders
  }

  getOrderServiceCollectiveOrders = () => {
    if (!this.orderServiceCollectiveOrders) {
      this.orderServiceCollectiveOrders = new OrderServiceCollectiveOrders(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.orderServiceCollectiveOrders
  }

  getCommunicationService = () => {
    if (!this.communicationService) {
      this.communicationService = new CommunicationService(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.communicationService
  }

  getCalculationService = () => {
    if (!this.calculationService) {
      this.calculationService = new CalculationService(this.endpointUrl, () =>
        this.getToken(),
      )
    }
    return this.calculationService
  }

  getCalculationServiceDistance = () => {
    if (!this.calculationServiceDistance) {
      this.calculationServiceDistance = new CalculationServiceDistance(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServiceDistance
  }
  getCalculationServiceGreenGRP = () => {
    if (!this.calculationServiceGreenGRP) {
      this.calculationServiceGreenGRP = new CalculationServiceGreenGRP(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServiceGreenGRP
  }
  getCalculationServiceLogistics = () => {
    if (!this.calculationServiceLogistics) {
      this.calculationServiceLogistics = new CalculationServiceLogistics(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServiceLogistics
  }
  getCalculationServicePacktech = () => {
    if (!this.calculationServicePacktech) {
      this.calculationServicePacktech = new CalculationServicePacktech(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServicePacktech
  }
  getCalculationServicePrintPaperPackagingPublishing = () => {
    if (!this.calculationServicePrintPaperPackagingPublishing) {
      this.calculationServicePrintPaperPackagingPublishing =
        new CalculationServicePrintPaperPackagingPublishing(
          this.endpointUrl,
          () => this.getToken(),
        )
    }
    return this.calculationServicePrintPaperPackagingPublishing
  }
  getCalculationServiceRotho = () => {
    if (!this.calculationServiceRotho) {
      this.calculationServiceRotho = new CalculationServiceRotho(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServiceRotho
  }
  getCalculationServiceTravel = () => {
    if (!this.calculationServiceTravel) {
      this.calculationServiceTravel = new CalculationServiceTravel(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServiceTravel
  }
  getCalculationServiceVehicleFleet = () => {
    if (!this.calculationServiceVehicleFleet) {
      this.calculationServiceVehicleFleet = new CalculationServiceVehicleFleet(
        this.endpointUrl,
        () => this.getToken(),
      )
    }
    return this.calculationServiceVehicleFleet
  }
  getCalculationServiceWasteManagement = () => {
    if (!this.calculationServiceWasteManagement) {
      this.calculationServiceWasteManagement =
        new CalculationServiceWasteManagement(this.endpointUrl, () =>
          this.getToken(),
        )
    }
    return this.calculationServiceWasteManagement
  }

  getToken = async () => {
    return await this.getStsService().getToken()
  }
}

export const ClimatePartnerApi = UnifiedApi

export {
  CalculationService,
  CalculationServiceDistance,
  CalculationServiceGreenGRP,
  CalculationServiceLogistics,
  CalculationServicePacktech,
  CalculationServicePrintPaperPackagingPublishing,
  CalculationServiceRotho,
  CalculationServiceTravel,
  CalculationServiceVehicleFleet,
  CalculationServiceWasteManagement,
  CommunicationService,
  HealthcheckService,
  OrderServiceCollectiveOrders,
  OrderServiceIndividualOrders,
  StsService,
}
export type { UnifiedApiConfiguration }

export * as CalculationModels from '../publish/calculation/models'
export * as CommunicationModels from '../publish/communication/models'
export * as HealthcheckModels from '../publish/healthcheck/models'
export * as OrderModels from '../publish/order/models'
export * as StsModels from '../publish/sts/models'
